import {
  CREATE_PRODUCT_UNIT,
  DELETE_PRODUCT_UNIT,
  UPDATE_PRODUCT_UNIT,
} from "../rest-api/mutations/productUnit"

import {
  GET_PRODUCT_UNIT,
  GET_PRODUCT_UNITS,
} from "../rest-api/queries/productUnit"
import { useMutation, useQuery } from "@tanstack/react-query"

export default function useProductUnit(params, id) {
  const productUnits = useQuery(["productUnits", params], () =>
    GET_PRODUCT_UNITS(params)
  )
  const productUnit = useQuery(["productUnit", id], () => GET_PRODUCT_UNIT(id))
  const createProductUnit = useMutation(CREATE_PRODUCT_UNIT, {
    onSuccess: (response) => {
      productUnits.refetch()
    },
  })
  const updateProductUnit = useMutation(UPDATE_PRODUCT_UNIT, {
    onSuccess: (response) => {
      productUnits.refetch()
    },
  })
  const deleteProductUnit = useMutation(DELETE_PRODUCT_UNIT, {
    onSuccess: (response) => {
      productUnits.refetch()
    },
  })

  return {
    productUnits,
    productUnit,
    createProductUnit,
    updateProductUnit,
    deleteProductUnit,
  }
}
